import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';
import 'font-awesome/css/font-awesome.min.css'
import { Helmet, HelmetProvider } from 'react-helmet-async';

const app = (
    <HelmetProvider>
        <>
            <Helmet>
                <title>{process.env.REACT_APP_PLATFORM} - Admin Panel</title>
            </Helmet>
            <App />
        </>
    </HelmetProvider>
)
ReactDOM.render(
    app,
    document.getElementById('root'),
);
